import { notFoundRouteCase, route } from '@shared/Frontend/router'
import { RouteBuilders, Routes, RouteUpdaters } from '@shared/Frontend/utils/routes.shared'
import { application } from '../allIncludedModules'
import { initialMonadsTestState } from '../libraries/monadsTest/monadsTest.state'
import { RootState } from '../libraries/root/root.state'
import { Pages } from './page.state'

export const errorHandlingTestPath = '/error-handling-test'
export const aboutUsPath = '/about-us'
export const contactUsPath = '/contact-us'
export const datesTestPage = '/dates'
export const monadsTestPage = '/monads'

const routeBuilders: RouteBuilders<Pages> = {
  empty: { make: (params) => ({ kind: 'empty', params }) },
  home: { make: (params) => ({ kind: 'home', params }) },
  errorHandlingTest: { make: (params) => ({ kind: 'errorHandlingTest', params }) },
  aboutUs: { make: (params) => ({ kind: 'aboutUs', params }) },
  contactUs: { make: (params) => ({ kind: 'contactUs', params }) },
  datesTest: { make: (params) => ({ kind: 'datesTest', params }) },
  monadsTest: { make: (params) => ({ kind: 'monadsTest', params, monadsTest: initialMonadsTestState }) },
  ...application.routeBuilders(),
}

const routeUpdaters: RouteUpdaters<RootState, Pages> = {
  empty: {
    jumpTo:
      (params) =>
      (state): RootState => ({ ...state, page: routeBuilders.empty.make(params) }),
    url: '',
  },
  home: {
    jumpTo:
      (params) =>
      (state): RootState => ({ ...state, page: routeBuilders.home.make(params) }),
    url: '/',
  },
  errorHandlingTest: {
    jumpTo:
      (params) =>
      (state): RootState => ({ ...state, page: routeBuilders.errorHandlingTest.make(params) }),
    url: errorHandlingTestPath,
  },
  aboutUs: {
    jumpTo:
      (params) =>
      (state): RootState => ({ ...state, page: routeBuilders.aboutUs.make(params) }),
    url: aboutUsPath,
  },
  contactUs: {
    jumpTo:
      (params) =>
      (state): RootState => ({ ...state, page: routeBuilders.contactUs.make(params) }),
    url: contactUsPath,
  },
  datesTest: {
    jumpTo:
      (params) =>
      (state): RootState => ({ ...state, page: routeBuilders.datesTest.make(params) }),
    url: datesTestPage,
  },
  monadsTest: {
    jumpTo:
      (params) =>
      (state): RootState => ({ ...state, page: routeBuilders.monadsTest.make(params) }),
    url: monadsTestPage,
  },
  ...application.routeUpdaters<RootState, Pages>(),
}

const routeObject: Routes<RootState, Pages> = {
  empty: route(routeUpdaters.empty.url, routeUpdaters.empty.jumpTo),
  home: route(routeUpdaters.home.url, routeUpdaters.home.jumpTo),
  errorHandlingTest: route(routeUpdaters.errorHandlingTest.url, routeUpdaters.errorHandlingTest.jumpTo),
  aboutUs: route(routeUpdaters.aboutUs.url, routeUpdaters.aboutUs.jumpTo),
  contactUs: route(routeUpdaters.contactUs.url, routeUpdaters.contactUs.jumpTo),
  datesTest: route(routeUpdaters.datesTest.url, routeUpdaters.datesTest.jumpTo),
  monadsTest: route(routeUpdaters.monadsTest.url, routeUpdaters.monadsTest.jumpTo),
  ...application.routeObject<RootState, Pages>(),
}

export const routes = [
  routeObject.home,
  routeObject.errorHandlingTest,
  routeObject.aboutUs,
  routeObject.contactUs,
  routeObject.datesTest,
  routeObject.monadsTest,
  ...application.routes<RootState, Pages>(),
  notFoundRouteCase(() => routeUpdaters.empty.jumpTo({})),
]
